import type { QuoteResponse } from '../lib/api';

interface OrderSummaryProps {
  items: Array<{ productUid: string; quantity: number; fileUrl: string }>;
  quote: QuoteResponse | null;
}

export function OrderSummary({ items, quote }: OrderSummaryProps) {
  return (
    <div className="card">
      <h3>Bestellübersicht</h3>
      {items.length === 0 ? (
        <p className="text-muted">Noch keine Produkte hinzugefügt.</p>
      ) : (
        <>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {items.map((item, i) => (
              <li
                key={i}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '0.5rem 0',
                  borderBottom: '1px solid var(--border)',
                }}
              >
                <span>
                  {item.productUid} × {item.quantity}
                </span>
              </li>
            ))}
          </ul>
          {quote && (
            <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Zwischensumme</span>
                <span>
                  {(quote.amount / 100).toFixed(2)} {quote.currency}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Versand</span>
                <span>
                  {(quote.shippingAmount / 100).toFixed(2)} {quote.currency}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Steuer</span>
                <span>
                  {(quote.taxAmount / 100).toFixed(2)} {quote.currency}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  marginTop: '0.5rem',
                }}
              >
                <span>Gesamt</span>
                <span>
                  {((quote.amount + quote.shippingAmount + quote.taxAmount) / 100).toFixed(2)} {quote.currency}
                </span>
              </div>
              <p className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>
                Voraussichtliche Lieferung: {new Date(quote.estimatedDelivery).toLocaleDateString('de-DE')}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
